import { z } from 'zod';

export const financePreferenceSchema = z.enum(['FINANCE', 'OUTRIGHT', 'UNSURE']);

export type FinancePreference = z.infer<typeof financePreferenceSchema>;

export const leadSchema = z.object({
  id: z.string().uuid(),
  call_id: z.string().uuid(),
  campaign_id: z.string().uuid().nullable().optional(),
  customer_name: z.string(),
  phone_number: z.string(),
  vehicle_interest: z.string().nullable().optional(),
  budget: z.string().nullable().optional(),
  finance_preference: financePreferenceSchema.nullable().optional(),
  showroom_interest: z.boolean().nullable().optional(),
  preferred_callback_time: z.string().nullable().optional(),
  additional_notes: z.string().nullable().optional(),
  created_at: z.date().or(z.string().datetime()),
});

export type Lead = z.infer<typeof leadSchema>;

export const leadWithRelationsSchema = leadSchema.extend({
  call: z.any().optional(),
  campaign: z.any().optional(),
});

export type LeadWithRelations = z.infer<typeof leadWithRelationsSchema>;

// Lead query schema for pagination and filtering
export const leadQuerySchema = z.object({
  // Pagination
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(10),

  // Enum filters
  finance_preference: financePreferenceSchema.optional(),

  // Relationship filters
  campaign_id: z.string().uuid().optional(),

  // Text search on customer_name or phone_number
  search: z.string().optional(),

  // Date range filter for created_at
  createdAtFrom: z.coerce.date().optional(),
  createdAtTo: z.coerce.date().optional(),

  // Sorting
  sortBy: z.enum(['created_at', 'customer_name', 'phone_number']).default('created_at'),
  sortOrder: z.enum(['asc', 'desc']).default('desc'),
});

export type LeadQuery = z.infer<typeof leadQuerySchema>;
